export default __webpack_public_path__ + "static/hadoop-0cb7a79e160e8a2e69cca954f5bd4c0f.png";